/**
 * Ein fehlender oder kaputter gespeicherter Wert faellt auf die Defaults ("kein Filter") zurueck,
 * damit eine beschaedigte Ansicht die Seite nicht mit einem Fehler blockiert.
 */
export function parseSavedViewFilters<T extends object>(filtersJson: string | null | undefined, defaults: T): T {
  if (!filtersJson) return defaults;
  let parsed: unknown;
  try {
    parsed = JSON.parse(filtersJson);
  } catch {
    return defaults;
  }
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) return defaults;
  const source = parsed as Partial<T>;
  const result = { ...defaults };
  for (const key of Object.keys(defaults) as (keyof T)[]) {
    result[key] = source[key] ?? defaults[key];
  }
  return result;
}

export function buildSavedViewFiltersJson<T>(filters: T): string {
  return JSON.stringify(filters);
}
